// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"fd675355","7582":"7640bbe3"}[chunkId] + ".chunk.css";
};